// @flow
import {
    ADD_CHILDREN_TO_DASHBOARD,
    BRIDGE_NODE_CREATED,
    BRIDGE_STATUS_UPDATE,
    hueBridgeStatuses,
    PAIR_WITH_BRIDGE,
    POLL_HUE_BRIDGE_STATUS,
    SEARCH_FOR_BRIDGE
} from './constants';

import { createAction } from 'redux-actions';

export const searchForBridge = createAction(SEARCH_FOR_BRIDGE, bridgeId => ({
    bridgeId
}));

export const bridgeNodeCreated = createAction(BRIDGE_NODE_CREATED);

export const pollBridgeStatus = createAction(POLL_HUE_BRIDGE_STATUS, (bridgeId, currentStatus) => ({
    bridgeId,
    currentStatus
}));
export const bridgeStatusUpdated = createAction(BRIDGE_STATUS_UPDATE);

export const pairWithBridge = createAction(PAIR_WITH_BRIDGE, bridgeId => ({
    bridgeId,
    currentStatus: hueBridgeStatuses.RETRY
}));

export const addChildrenToDashboard = createAction(ADD_CHILDREN_TO_DASHBOARD, parent => ({
    parent
}));



// WEBPACK FOOTER //
// ./src/core/state/install-hue-bridge/actions.js